import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import WhoWeAre from './pages/WhoWeAre';
import Team from './pages/Team';
import CoatHangers from './pages/Coat-Hangers';
import SofaSets from './pages/Sofa-Sets';
import Equipment from './pages/Equipment';
import OfficeFurniture from './pages/Office-Furniture';
import HomeFurniture from './pages/Home-Furniture';
import Beds from './pages/Beds';
import Wardrobes from './pages/Wardrobes';
import Services from './pages/Services';
import Clients from './pages/Clients';
import Gallery from './pages/Gallery';
import Certification from './pages/Certification';
import Contact from './pages/Contact';
import Telecom from './pages/Telecom';
import Power from './pages/Power';
import WaterDispensers from './pages/Water-Dispensers';
import OfficeSofas from './pages/Office-Sofas';
import Desks from './pages/Office-Desks';
import OfficeChairs from './pages/Office-Chairs';
import CabinetsShelves from './pages/Office-Cabinets';
import BoardroomTables from './pages/Boardroom-Tables';
import DiningTables from './pages/Dining-Tables';
import CenterTable from './pages/Center-Table';
import TVStands from './pages/TV-Stands';
import KitchenCabinets from './pages/Kitchen-Cabinets';
import CB from './pages/Curtains-Blinds';
import Curtains from './pages/Curtains';
import MN from './pages/Mosquito-Nets';
import CR from './pages/Curtain-Rods';
import VB from './pages/Vertical-Blinds';
import RB from './pages/Roller-Blinds';
import Venetian from './pages/Venetian-Blinds';
import Decor from './pages/Decor';
import Error from './pages/Error';
import Footer from "./components/Footer";
import Nav from "./components/Nav";
import TopSection from "./components/TopSection";
import WhatsAppIcon from "./components/WhatsAppIcon";
import BackToTop from "./components/BackToTop";
import Health from "./pages/HealthPolicy";
import Environment from "./pages/EnvironmentalPolicy";

function App() {
  return (
    <BrowserRouter>
    <TopSection></TopSection>
      <Nav></Nav>
       <Routes>
            <Route path='/' element={<Home></Home>}></Route>
            <Route path='about' element={<WhoWeAre></WhoWeAre>}></Route>
            <Route path='our-team' element={<Team></Team>}></Route>
            <Route path='services' element={<Services></Services>}></Route>
            <Route path='clients' element={<Clients></Clients>}></Route>
            <Route path='pictorial' element={<Gallery></Gallery>}></Route>
             <Route path='equipment' element={<Equipment></Equipment>}></Route>
             
            <Route path='certifications' element={<Certification></Certification>}></Route>
             <Route path='inquiries' element={<Contact></Contact>}></Route>
             <Route path='*' element={<Error></Error>}></Route>
             {/* Footer Services Links */}
 <Route path='telecom' element={<Telecom></Telecom>}></Route>
 <Route path='power' element={<Power></Power>}></Route>
 <Route path='water-dispensers' element={<WaterDispensers></WaterDispensers>}></Route>
 <Route path='coat-hangers' element={<CoatHangers></CoatHangers>}></Route>
  <Route path='office-sofas' element={<OfficeSofas></OfficeSofas>}></Route>
  <Route path='office-desks' element={<Desks></Desks>}></Route>
  <Route path='office-chairs' element={<OfficeChairs></OfficeChairs>}></Route>
  <Route path='cabinets-shelves' element={<CabinetsShelves></CabinetsShelves>}></Route> 
   <Route path='boardroom-tables' element={<BoardroomTables></BoardroomTables>}></Route>
   <Route path='office-furniture' element={<OfficeFurniture></OfficeFurniture>}></Route>  
   <Route path='home-furniture' element={<HomeFurniture></HomeFurniture>}></Route>
   <Route path='sofa-sets' element={<SofaSets></SofaSets>}></Route>  
  <Route path='dining-tables' element={<DiningTables></DiningTables>}></Route>      
  <Route path='beds' element={<Beds></Beds>}></Route>        
  <Route path='wardrobes' element={<Wardrobes></Wardrobes>}></Route> 
 <Route path='center-tables' element={<CenterTable></CenterTable>}></Route>
 <Route path='tv-stands' element={<TVStands></TVStands>}></Route> 
 <Route path='kitchen-cabinets' element={<KitchenCabinets></KitchenCabinets>}></Route> 
 <Route path='curtains-blinds' element={<CB></CB>}></Route>  
<Route path='curtains' element={<Curtains></Curtains>}></Route>
<Route path='mosquito-nets' element={<MN></MN>}></Route>  
<Route path='curtain-rods' element={<CR></CR>}></Route>  
<Route path='vertical-blinds' element={<VB></VB>}></Route>
<Route path='roller-blinds' element={<RB></RB>}></Route>  
<Route path='venetian-blinds' element={<Venetian></Venetian>}></Route>
<Route path='decor-accessories' element={<Decor></Decor>}></Route> 
<Route path='health-safety-policy' element={<Health></Health>}></Route>
<Route path='environmental-policy' element={<Environment></Environment>}></Route>            
       </Routes>
       <WhatsAppIcon></WhatsAppIcon><BackToTop></BackToTop>
       <Footer></Footer>
    </BrowserRouter>
  );
}

export default App;
